"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importStar(require("react"));
const TabsContext_1 = require("./TabsContext");
const TabList_1 = require("./components/TabList");
const TabPanel_1 = require("./components/TabPanel");
/**
 * @deprecated please use <Ds.Tabs/> instead
 */
const Tabs = ({ onTabChange, children, defaultSelected, selected, }) => {
    const [selectedTabId, setSelectedTabId] = (0, react_1.useState)(defaultSelected);
    // track the tab panels that get registered
    const tabPanels = (0, react_1.useRef)([]);
    const registerTabPanel = (0, react_1.useCallback)((tabId) => {
        if (tabId && tabPanels.current.indexOf(tabId) === -1) {
            tabPanels.current.push(tabId);
        }
    }, []);
    // If we're changing the panels during the component lifecycle, need to remove it from the list
    const unregisterTabPanel = (0, react_1.useCallback)((tabId) => {
        const removeIndex = tabPanels.current.indexOf(tabId);
        if (tabId && removeIndex !== -1) {
            tabPanels.current.splice(removeIndex, 1);
        }
    }, []);
    const getTabPanels = (0, react_1.useCallback)(() => {
        return [...tabPanels.current];
    }, []);
    const handleTabChange = (0, react_1.useCallback)(({ tabId, isUserSelect }) => {
        setSelectedTabId(tabId);
        isUserSelect && onTabChange && onTabChange(tabId);
    }, []);
    return (react_1.default.createElement(TabsContext_1.TabsProvider, { value: {
            registerTabPanel,
            unregisterTabPanel,
            getTabPanels,
            selectedTabId: selected ? selected : selectedTabId,
            setSelectedTabId: handleTabChange,
        } }, children));
};
exports.Tabs = Tabs;
Tabs.TabList = TabList_1.TabList;
Tabs.Panel = TabPanel_1.TabPanel;
//# sourceMappingURL=Tabs.js.map